import React, { createContext, useCallback, useState, useContext, useEffect } from 'react';


import { useSocket } from './Socket';
import { useAuth } from './Auth';
 
import api from 'src/services/api';
import { createGlobalStyle, css } from 'styled-components';
import { loadFromApiJson } from 'src/services/loadFromApiJson';
import { background } from '../config';



interface ConfigurationState {
  token: string;
  user: Record<string, any>;
}

interface IOption {
  type: string;
  id: string;
  subtype: string;
  value: string;
}

interface ISignInAdmin {
  email: string;
  password?: string;
}

interface IConfiguration {
  _id?: string;
  color?: string;
  title?: string;
  description?: string;
  url?: string;
  program_title?: string;
  program_subtitle?: string;
  logo?: string;
  logo_main?: string;
  logo_adicional?: string;
  logo_adicional2?: string;
  upper_text?: string;
  header_image?: string;
  data_image?: string;
  lower_text?: string;
  next_date?: Date;
  header_video?: string;
  fixed_image_header?: string;
  background?: string;
  background_color?: string;
  certificates?: string;
  home_image_is_full?: string;
  theme_data?: Record<string, any>;
  current_event_id_response?: Record<string, any>;
  active_pages?: Array<Record<string, any>>;
  video_display?: string;
  video_type?: string;
  video_display_hash?: string;
  program_list?: string;
  event_id_response?: Record<string, any>;
  program_theme_data?: Record<string, any>;
  room_list_template?: string;
  exclusive?: string;
  have_language?: string;
  languages?: Record<string, any>;
  cracha_config?: Record<string, any>;
  cracha_have_qrcode?: string;
  allow_credit_card?: string;
  have_password?: string;
  sign_in_type?: string;
  allow_boleto?: string;
  allow_pix?: string;
  allow_cientific_submission?: string;
  allow_cientific_poster_submission?: string;
  haveTranslate?: string;
  header_image2?: string;
}

interface IGame {
  reference?: string;
  points?: number;
  id?: number;
}

interface ConfigurationContextData {

  configuration: IConfiguration;
  setConfiguration(data: IConfiguration): void;
  platformConfiguration: IPlatform;
  globalConfiguration: Record<string, any>;
  projectHash?: string;
  eventHash?: string;
  getToken: Function;
  hash: string;

}

interface IPlatform {
  urlWebsite: string;
  websitePath: string;
  hash: string;
  authTitle: string;
  logo?: string;
  supportNumber?: string;
  default_project?: string;
}

interface IGlobal {
  font_title: string;
  font_paragraph: string;
    font_semibold: string;
  theme: Record<string, any>;
  default_project: string;
  supportNumber?: string;
  popup_images?: Array<Record<string, any>>;
  popup_status?: string;
}

interface IPropsFont {
  font_title: string;
  font_paragraph: string;
      font_semibold: string;
  background: string;
}

const GlobalStyle = createGlobalStyle<IPropsFont>`

${props => props?.font_title && css`
@font-face {
    font-family: 'CustomFontBold';
    src: url('${props.font_title}') format('truetype');
  }

`}
 
 ${props => props?.font_paragraph && css`
@font-face {
    font-family: 'CustomFont';
    src: url('${props.font_paragraph}') format('truetype');
  }

`}


 ${props => props?.font_semibold && css`
@font-face {
    font-family: 'CustomFontSemiBold';
    src: url('${props.font_semibold}') format('truetype');
  }

`}



${props => props?.background && css`
 body{
   background: ${props?.background} !important;
 }

`}




  .greenButton3{
    padding: 10px 16px !important;
    background: #ddd ;
    color:#000 ;
    font-size: 14px;
    line-height: 18px;
    border: 0px;
    border-radius: 10px;
  //  margin: 10px 0px;
    transition: 0.4s all;
    font-weight: bold;

    display: flex !important ;
    gap: 5px  !important;
    justify-content: center  !important;
    align-items: center  !important;
    flex-direction: row  !important;

    &:hover{
      transform: scale(1.15) ;
    }
  }


.greenButton2{
    padding: 16px 24px !important;
    background: #ddd ;
    color:#000 ;
    font-size: 20px;
    line-height: 16px;
    border: 0px !important;
    border-radius: 10px;
  //  margin: 10px 0px;
    transition: 0.4s all;
    font-weight: bold;

    display: flex !important ;
    gap: 5px ;
    justify-content: center  !important;
    align-items: center  !important;
    flex-direction: row  !important;

    &:hover{
      transform: scale(1.15) ;
    }
  }
  
`;

const ConfigurationContext = createContext<ConfigurationContextData>({} as ConfigurationContextData);




export async function loadConfigData() {
 // const currentDomain = window.location.hostname;
  
    const currentDomain = 'avc.encontrodigital.com.br'; 
    const domainreplace = currentDomain?.replace('https://', '').replace(/\//g, '').replace(/\./g, '-');
    const response = await fetch(`https://content.encontrodigital.com.br/configs/${domainreplace}/index.json`);
    const config = await response.json();
  
 

 /* const config: IPlatform = {
    hash: "c1077dd7-d3fb-4aca-b90c-1cbd2ffffdc9",
    urlWebsite: "https://recebasempre.encontrodigital.com.br",
    websitePath: "https://recebasempre.encontrodigital.com.br",
    authTitle: 'Receba Sempre',
    logo: '/assets/logo.png',
    supportNumber: '999999999',
    default_project: 'event'
  }
    */

  return config;

}



const ConfigurationProvider: React.FC<Record<string, any>> = ({ children }) => {
  const { socket } = useSocket();
  const { user } = useAuth();
  const [configuration, setConfiguration] = useState<Record<string, any>>({});

  const projectHash = configuration?.url || '';
  const eventHash = configuration?.current_event_id_response?.url || '';

  const [platformConfiguration, setPlatformConfiguration] = useState<IPlatform>({} as IPlatform);
  const [globalConfiguration, setGlobalConfiguration] = useState<Record<string, any>>({} as Record<string, any>);




  const loadGlobal = async (hash: string, websiteUrl: string) => {

    const item = await loadFromApiJson({ hash: hash, project_id: 'global', table: 'Global' })

    let data: Record<string, any> = {};
    if (!item) {
      const config = await api.get('/get_platform');

      data = config.data;
    }
    else {
      data = item?.[0] || {}
    }

    const theme = data?.theme?.find( i => i?.title === 'default') || {
      background: '#fff',
      color: '#333',
      menu_color : '#333',
      menu_background: '#fff',
      loading_background: '#fff',
      loading_color: '#333'


    }

    data.themecontent = theme;

    setGlobalConfiguration(data)

    return data;
  }

  const getToken = (): string | null => {
    const token = localStorage.getItem(`@${platformConfiguration?.hash}:token`);
    return token;
  };


  const hash = platformConfiguration?.hash || '';

  const loadContent = async () => {


    const dataContent = await loadConfigData();

    setPlatformConfiguration(dataContent)

  }
  useEffect(() => {

    loadContent();

  }, [])


  useEffect(() => {

    if (platformConfiguration?.hash) {
      loadGlobal(platformConfiguration?.hash, platformConfiguration?.urlWebsite)
    }

  }, [platformConfiguration])

  
 
  return (
    <ConfigurationContext.Provider
      value={{
        configuration,
        setConfiguration,
        projectHash,
        eventHash,
        platformConfiguration,
        globalConfiguration,
        getToken,
        hash
      }}
    >
      {globalConfiguration && platformConfiguration ? <GlobalStyle
         font_semibold={globalConfiguration?.font_semibold ? `https://content.encontrodigital.com.br/${globalConfiguration?.font_semibold}` : ''}
        font_title={globalConfiguration?.font_title ? `https://content.encontrodigital.com.br/${globalConfiguration?.font_title}` : ''}
        font_paragraph={globalConfiguration?.font_paragraph ? `https://content.encontrodigital.com.br/${globalConfiguration?.font_paragraph}` : ''}
        background={``}


      /> : <></>}
      {children}
    </ConfigurationContext.Provider>
  );
};

function useConfiguration(): ConfigurationContextData {
  const context = useContext(ConfigurationContext);

  if (!context) {
    throw new Error('useConfiguration must be used within an ConfigurationProvider');
  }

  return context;
}

export { ConfigurationProvider, useConfiguration };
